// extracted by mini-css-extract-plugin
module.exports = {"root":"ScreenSizeSwitcher_root__uREsF","device":"ScreenSizeSwitcher_device__2nr3Q","rotate":"ScreenSizeSwitcher_rotate__1g6ii","landscape":"ScreenSizeSwitcher_landscape__1Kbem"};